import commonInput from './commonInput/commonInput.vue';
import commonSelect from './commonSelect/commonSelect.vue';
import dateSelect from './dateSelect/dateSelect.vue';
import meetingRoomRadio from './meetingRoomRadio/meetingRoomRadio.vue';
import meetingPersonal from './meetingPersonal/meetingPersonal.vue';
import commonRadio from './commonRadio/commonRadio.vue';
import meetingSetting from './meetingSetting/meetingSetting.vue';
import submitMeeting from './submitMeeting/submitMeeting.vue';
import meetingSpace from './meetingSpace/meetingSpace.vue';
import inviteJoinToast from './inviteJoinToast/inviteJoinToast.vue';
import commonCheckBox from './commonCheckBox/commonCheckBox.vue';
import supportCode from './supportCode/supportCode.vue';
import globalDate from './globalDate/globalDate.vue';
import addEmail from './addEmail/addEmail.vue';
import noMessage from './noMessage/nomessage.vue';
import metingFrequency from './metingFrequency/metingFrequency.vue';
import historySelect from './historySelect/historySelect.vue';
import friendlyReminder from './friendlyReminder/friendlyReminder.vue';
import newUserTip from './newUserTip/newUserTip.vue';
import joinTip from './joinTip/joinTip.vue';
import videoResource from './videoResource/videoResource.vue';
import countDown from './countDown/countDown.vue';
import meetingRenew from './meetingRenew/meetingRenew.vue';


export default {
  install(app) {
    app.component('count-down', countDown);
    app.component('common-input', commonInput);
    app.component('common-select', commonSelect);
    app.component('date-select', dateSelect);
    app.component('meeting-room-radio', meetingRoomRadio);
    app.component('meeting-personal', meetingPersonal);
    app.component('common-radio', commonRadio);
    app.component('meeting-setting', meetingSetting);
    app.component('submit-meeting', submitMeeting);
    app.component('meeting-space', meetingSpace);
    app.component('invite-join-toast', inviteJoinToast);
    app.component('common-checkBox', commonCheckBox);
    app.component('support-code', supportCode);
    app.component('global-date', globalDate);
    app.component('addEmail', addEmail);
    app.component('no-message', noMessage);
    app.component('meting-frequency', metingFrequency);
    app.component('history-select', historySelect);
    app.component('friendly-reminder', friendlyReminder);
    app.component('new-user-tip', newUserTip);
    app.component('join-tip', joinTip);
    app.component('video-resource', videoResource);
    app.component('meeting-renew', meetingRenew);
  }
}
